/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ProfilePage = lazy(() => import('./ProfilePage'))

export const profiloRoutes: RouteObject[] = [
  {
    path: 'profilo',
    element: <ProfilePage />,
  },
]
